import React, { useState } from "react"
import { ListGroup, ListGroupItem, Container } from "reactstrap"
import { NavLink } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Trans, useLingui } from "@lingui/react"
import PropTypes from "prop-types"
import { toast } from "react-toastify"
import { connect } from "react-redux"
import { fetchMeeting, meetingLoaded } from "../../store/actions/meetings/getMeeting"
import { patchMeeting } from "../../store/actions/meetings/createMeeting"

import { selectCreatedVslaInfo } from "../../store/reducers/getVslas"
import { setCurrentPage } from "../../store/reducers/navigation"
import { t } from "@lingui/macro"
import CustomModal from "../layout/Modal"
import { updateGroupSettings } from "../../store/actions/createVsla"
import { patchGroupItem } from "../../store/actions/updateVslaAndGroup"
import validateInput from "../../view/shared/validations/validateAmount"

const linkReverseStyles = {
  display: "flex",
  justifyContent: "space-between",
}



const successStyle = {
  fontFamily: "quicksand",
  fontSize: "20px",
  color: "green",
  fontWeight: "bolder",
}

const BackbuttonStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "6px 12px",
  width: "62px",
  height: "36px",
  color: "#fff",
  fontFamily: "Quicksand",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 600,
  background: "#6C757D",
  borderRadius: "4px",
  flex: "none",
  border: "0",
  alignSelf: "stretch",
  flexGrow: "0",
  textTransform: "capitalize",
  marginRight: "0.5em",
}

const ContbuttonStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "6px 12px",
  width: "93px",
  height: "36px",
  color: "#fff",
  fontFamily: "Quicksand",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 600,
  background: "#E36F1E",
  borderRadius: "4px",
  flex: "none",
  border: "0",
  alignSelf: "stretch",
  flexGrow: "0",
  textTransform: "capitalize",
  marginRight: "0.5em",
}

export const SuccessMessage = () => {
  return (
    <div style={loadingStyle}>
      <Trans id="meeting.ended.successfully">Meeting ended successfully</Trans>
    </div>
  )
}

export const ErrorMessage = () => {
  return (
    <div style={loadingStyle}>
      <Trans id="error.ending.meeting">Error ending meeting</Trans>
    </div>
  )
}

export const UpdatedSuccessMessage = () => {
  return (
    <div style={successStyle}>
      <Trans id="share.value.updated">Share value updated</Trans>
    </div>
  )
}

const MeetingsMenu = (props) => {
  const { i18n } = useLingui()
  const [iconStyle, setIconStyle] = React.useState(
    {
      fontSize: "20px",
      float: "right",
      color: "#536A81",
      transform: i18n.locale === "ar" ? "rotateY(180deg)" : "none",
    }
  )

  React.useEffect(() => {
    setIconStyle(prevState => ({
      ...prevState,
      transform: i18n.locale === "ar" ? "rotateY(180deg)" : "none",
    }))
  }, [i18n.locale])
  const notify = (msg) => toast(msg)
  const [isOpen, setIsOpen] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [modalFirstBtnName, setModalFirstBtnName] = useState("")
  const [modalSecBtnName, setModalSecBtnName] = useState("")
  const [modalBtnDisable, setModalBtnDisable] = useState(false)
  const [cycleData, setNewCycleData] = useState({
    duration: null,
    value: null,
  })
  const [errors, setErrors] = useState({})

  const endMeeting = async () => {
    const lang_code = i18n.locale
    const lang = {
      fr: {
        message: `Voulez-vous vraiment terminer la réunion?`,
      },
      en: {
        message: `Are you sure you want to end the meeting?`,
      },
      sw: {
        message: `Una uhakika unataka kufunga mkutano?`,
      },
      za: {
        message: `Akiika kaŋ ni ga ba ma marga ban ne?`,
      },
      ha: {
        message: `Tabbat ki na so ki ƙare taron ỳanzun nan?`,
      },
      es: {
        message: `¿Está seguro de que desea finalizar la reunión?`,
      },
      lb: {
        message: `Are you sure you want to end the session?`,
      },
      ar: {
        message: "هل انت متاكد انك تريد انهاء الجلسة",
      },
      pt: {
        message: `Tem certeza de que deseja encerrar a reunião?`,
      },
    }

    const pendingTransactions = props.meetingTransactions.filter(
      ({ status, isOffline }) => status.toLocaleLowerCase() === "pending" && !isOffline,
    )

    if (pendingTransactions.length) {
      alert(t({ id: "Cannot end meeting with pending transactions" }))
      return
    }

    if (window.confirm(lang[lang_code].message)) {
      const meeting = props.ongoingMeeting
      const group_name = props.group?.name

      const notif = {
        en: {
          message: `The secretary has ended a meeting for ${group_name} group on VSLA Online`,
        },
        fr: {
          message: `FRA - The secretary has ended a meeting for ${group_name} group on VSLA Online`,
        },
        sw: {
          message: `SWA - The secretary has ended a meeting for ${group_name} group on VSLA Online`,
        },
        es: {
          message: `La secretaria ha terminado una reunión para el grupo ${group_name} en VSLA Online`,
        },
        lb: {
          message: `The officer has ended a session for ${group_name} community on VSLA.online`,
        },
        ar: {
          message: group_name,
        },
        pt: {
          message: `O/A secretário/a encerrou uma reunião para o grupo ${group_name} no VSLA Online`,
        },
      }

      const data = {
        date: meeting.date,
        status: "completed",
        group_id: meeting.group_id,
        msg: Object.values(notif[lang_code])[0],
      }
      props
        .patchOngoingMeeting(data)
        .then(() => {
          notify(<SuccessMessage />)
        })
        .catch(() => {
          notify(<ErrorMessage />)
        })
    }
  }

  const [hasError, setHasError] = React.useState(false)

  React.useEffect(() => {
    if (!props.offlineMeeting) {
      return
    }

    const meeting = props.offlineMeeting
    setHasError(
      (props.offlineMeeting.transactions || []).filter(({ status }) => status === "failed")
        .length > 0 || !!meeting.error,
    )
  }, [props.isConnected, props.offlineMeeting])

  const newMeeting = () => {
    if (props.offlineMeeting || hasError || props.isCreatingMeeting) {
      return
    }
    if (
      props.group?.can_change_share_value &&
      !["ar", "lb"].includes(i18n.locale)
    ) {
      setModalFirstBtnName(t({ id: "No" }))
      setModalSecBtnName(t({ id: "Yes" }))
      setIsDisabled(true)
      setIsOpen(true)
    } else props.setPage("group-createMeeting")
  }

  const onModalBtnClick = (params) => {
    if (params === "btn1" && modalFirstBtnName === t({ id: "No" })) {
      props.setPage("group-createMeeting")
      updateGroup()
    } else if (params === "btn1" && modalFirstBtnName === t({ id: "Cancel" })) {
      setIsOpen(false)
      setIsDisabled(true)
    }
    if (params === "btn2" && modalSecBtnName === t({ id: "Yes" })) {
      setIsDisabled(false)
      setModalFirstBtnName(t({ id: "Cancel" }))
      setModalSecBtnName(t({ id: "Save" }))
    } else if (params === "btn2" && modalSecBtnName === t({ id: "Save" })) {
      if (isValid()) {
        setErrors({})
        setModalSecBtnName(t({ id: "Saving" }))
        setModalBtnDisable(true)
        updateShareValue()
      }
    }
  }

  const isValid = () => {
    const { errors, isValid } = validateInput({
      amount: cycleData.inputNumber,
    })

    if (!isValid) {
      setErrors(errors)
    }

    return isValid
  }

  const updateShareValue = () => {
    const vsla = props.loadedVsla?.[0]
    let newVsla = Object.assign({}, vsla)
    newVsla.metadata.share_value = !cycleData.inputNumber
      ? vsla?.metadata?.share_value
      : cycleData.inputNumber
    newVsla.cycle_duration = cycleData.duration
    newVsla.metadata.fineCashOutType = vsla?.metadata?.fineCashOutType
    newVsla.metadata.welfareCashOutType = vsla?.metadata?.welfareCashOutType
    newVsla.metadata.membershipCashOutType = vsla?.metadata?.membershipCashOutType
    newVsla.metadata.loanInterestCashOutType = vsla?.metadata?.loanInterestCashOutType
    newVsla.metadata.savingsCashOutType = vsla?.metadata?.savingsCashOutType
    props
      .updateSettings(newVsla)
      .then(() => {
        //update group to change value of can_change_share_value
        updateGroup()
        notify(<UpdatedSuccessMessage />)
        props.setPage("group-createMeeting")
      })
      .catch((error) => {
        notify(<ErrorMessage />)
        throw new Error("Updating shares", error)
      })
  }

  const updateGroup = () => {
    // patch group in HOL
    const headers = {
      headers: {
        Authorization: "Bearer " + props.user.token || localStorage.getItem("token"),
      },
    }
    const vslaData = props.vslaSummary[0].group
    let temp = vslaData
    temp.can_change_share_value = false
    temp.cycle_duration = cycleData.cycleDuration
    const urlHOL = `/groups-hedera/group_update/${temp.id}`
    props.patchGroup(urlHOL, temp, headers)
  }

  if (!props.ongoingMeeting) {
    return (
      <div>
        <div
          style={{
            padding: ".5rem",
            textAlign: "center",
            margin: "34px 0 0 0",
          }}
        >
          <h4
            style={{
              color: "#E36F1E",
              fontFamily: "quicksand",
              fontWeight: "bolder",
            }}
          >
            <Trans id="meeting">Meeting</Trans>
          </h4>
        </div>
        <Container>
          <ListGroup flush>
            {props.group?.status === "Active" && (
              <ListGroupItem>
                <span
                  onClick={() => newMeeting()}
                  style={
                    i18n.locale === "ar"
                      ? linkReverseStyles
                      : {}
                  }
                >
                  <span
                    className="textStyle"
                    style={{
                      ...loadingStyle,
                      color: props.offlineMeeting || hasError ? "grey" : "initial",
                    }}
                  >
                    <Trans id="new.meeting">New Meeting</Trans>
                  </span>
                  <FontAwesomeIcon style={iconStyle} icon="angle-right" />
                </span>
              </ListGroupItem>
            )}
            <ListGroupItem>
              <span
                onClick={() => {
                  props.setPage("group-previousMeetings")
                }}
                style={
                  i18n.locale === "ar" ? linkReverseStyles : {}
                }
              >
                <span className="textStyle" style={loadingStyle}>
                  <Trans id="previous.meetings">Previous Meetings</Trans>
                </span>
                <FontAwesomeIcon style={iconStyle} icon="angle-right" />
              </span>
            </ListGroupItem>
            {props.offlineMeeting && (
              <ListGroupItem>
                <span
                  onClick={() => {
                    props.setPage("group-offlineMeeting")
                  }}
                  style={
                    i18n.locale === "ar"
                      ? linkReverseStyles
                      : {}
                  }
                >
                  <span className="textStyle" style={loadingStyle}>
                    <Trans id="offline.meeting">Offline Meeting</Trans>
                  </span>
                  {(props.offlineMeeting.transactions || []).filter(
                    ({ status }) => status === "failed",
                  ).length ? (
                    <FontAwesomeIcon
                      style={{
                        position: "absolute",
                        color: "red",
                      }}
                      icon="exclamation-circle"
                    />
                  ) : (
                    false
                  )}
                  <FontAwesomeIcon style={iconStyle} icon="angle-right" />
                </span>
              </ListGroupItem>
            )}
          </ListGroup>
          <CustomModal
            cycleDuration={props.vslaSummary[0].group.cycle_duration}
            modalHeader={t({ id: "Reminder" })}
            headerClassName="d-flex justify-content-center"
            bodyContent={t({ id: "Share value information" })}
            isCentered={true}
            showInput={true}
            isDisabled={isDisabled}
            errors={errors}
            getNewCycleData={setNewCycleData}
            showSavingsCycle={true}
            inputPlaceholder={parseFloat(props.group?.cycle?.shareValue)}
            isOpen={isOpen}
            footerContent={
              <div className="btn-toolbar">
                <button
                  className="btn"
                  disabled={modalBtnDisable}
                  onClick={() => onModalBtnClick("btn1")}
                  style={BackbuttonStyle}
                >
                  {modalFirstBtnName}
                </button>
                <button
                  className="btn btn-info"
                  disabled={modalBtnDisable}
                  onClick={() => onModalBtnClick("btn2")}
                  style={ContbuttonStyle}
                >
                  {modalSecBtnName}
                </button>
              </div>
            }
          />
        </Container>
      </div>
    )
  }

  return (
    <div>
      <br />

      <Container>
        <ListGroup flush>
          {!hasError && (
            <>
              <ListGroupItem>
                <span
                  onClick={() => {
                    props.setPage("group-memberList")
                  }}
                  style={
                    i18n.locale === "ar"
                      ? linkReverseStyles
                      : {}
                  }
                >
                  <span className="textStyle" style={loadingStyle}>
                    <Trans id="current.meeting">Current Meeting</Trans>
                  </span>
                  <FontAwesomeIcon style={iconStyle} icon="angle-right" />
                </span>
              </ListGroupItem>

              <ListGroupItem>
                <NavLink
                  onClick={endMeeting}
                  to={{
                    pathname: `/Groups`,
                  }}
                  style={
                    i18n.locale === "ar"
                      ? linkReverseStyles
                      : {}
                  }
                >
                  <span className="textStyle" style={loadingStyle}>
                    <Trans id="end.meeting">End Meeting</Trans>
                  </span>
                  <FontAwesomeIcon style={iconStyle} icon="angle-right" />
                </NavLink>
              </ListGroupItem>
            </>
          )}
          <ListGroupItem>
            <span
              onClick={() => props.setPage("group-previousMeetings")}
              style={
                i18n.locale === "ar" ? linkReverseStyles : {}
              }
            >
              <span className="textStyle" style={loadingStyle}>
                <Trans id="previous.meetings">Previous Meetings</Trans>
              </span>
              <FontAwesomeIcon style={iconStyle} icon="angle-right" />
            </span>
          </ListGroupItem>
          {props.offlineMeeting && (
            <ListGroupItem>
              <span
                onClick={() => {
                  props.setPage("group-offlineMeeting")
                }}
                style={
                  i18n.locale === "ar" ? linkReverseStyles : {}
                }
              >
                <span className="textStyle" style={loadingStyle}>
                  <Trans id="offline.meeting">Offline Meeting</Trans>
                </span>
                {hasError ? (
                  <FontAwesomeIcon
                    style={{
                      position: "absolute",
                      color: "red",
                    }}
                    icon="exclamation-circle"
                  />
                ) : (
                  false
                )}
                <FontAwesomeIcon style={iconStyle} icon="angle-right" />
              </span>
            </ListGroupItem>
          )}
        </ListGroup>
      </Container>
    </div>
  )
}

MeetingsMenu.propTypes = {
  vsla: PropTypes.object,
  meetingTransactions: PropTypes.array,
  ongoingMeeting: PropTypes.array,
  user: PropTypes.object,
  group: PropTypes.object,
  clearLoadedMeeting: PropTypes.func,
  patchOngoingMeeting: PropTypes.func,
  isConnected: PropTypes.bool,
  isCreatingMeeting: PropTypes.bool,
  setPage: PropTypes.func,
  groupVsla: PropTypes.object,
  updateSettings: PropTypes.func,
  vslaSummary: PropTypes.array,
  patchGroup: PropTypes.func,
  groupvsla: PropTypes.object,
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
  color: "initial",
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    isCreatingMeeting: state.isCreatingMeeting,
    isConnected: state.isConnected,
    vsla: state.vsla,
    group: state.group,
    ongoingMeeting: state.meeting?.ongoing,
    offlineMeeting: state.meeting?.ongoing?.cacheId ? state.meeting.ongoing : null,
    vslaSummary: selectCreatedVslaInfo(state),
    meetingTransactions: state.meetingTransactions,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearLoadedMeeting: () => dispatch(meetingLoaded([])),
    setPage: (page) => dispatch(setCurrentPage(page)),
    patchOngoingMeeting: (data) => dispatch(patchMeeting(data)),
    updateSettings: (data) => dispatch(updateGroupSettings(data)),
    patchGroup: (url, data, headers) => dispatch(patchGroupItem(url, data, headers)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MeetingsMenu)
